import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  confirm: () => void;
  cancel: () => void;
}

export const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  isOpen,
  confirm,
  cancel,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={cancel}
    title="Delete offer"
    modalClassName="w-full md:w-[670px]"
    centerContent={true}
  >
    <div className="flex flex-col gap-6">
      <Typography variant="body" size="large" fontWeight="normal">
        Are you sure you want to delete this offer? This action cannot be
        undone.
      </Typography>
      <div className="flex gap-4 justify-center">
        <Button
          variant="text"
          color="neutral"
          onClick={cancel}
          className="w-[180px]"
        >
          Go back
        </Button>
        <Button color="neutral" onClick={confirm} className="w-[180px]">
          Delete
        </Button>
      </div>
    </div>
  </Modal>
);
